import { useEffect, useState } from 'react';
import RightPanel from '../../../shared/components/RightPanelForm';
import { getHtzValues } from '../service/HtzService';
import styles from './PartSearchForm.module.css';

export default function PartSearchForm({ htz, queryColumns, screenGridId }) {
  const [rowData, setRowData] = useState(null);

  useEffect(() => {
    if (!htz) {
      return;
    }
    async function fetchRecord() {
      try {
        const result = await getHtzValues(htz, queryColumns, screenGridId);
        setRowData(result?.npi_qry_search);
      } catch (error) {
        console.error(error.message);
      }
    }
    fetchRecord();
  }, [htz]);

  if (!rowData) {
    return null;
  }

  return (
    <div className={styles.gridBox}>
      <RightPanel
        setisformpanelopen={() => {}}
        rows={rowData}
        rowValues={rowData[0]}
        disableFormClose={true}
      />
    </div>
  );
}
